import { Button, ModalHeader } from "@ondit/ui";
import { ArrowLeft } from "lucide-react";
import { createContext, type ReactNode, useCallback, useState } from "react";
import { pick, useI18n, useT } from "~/core/i18n";

type BackAction = { go: () => void; disabled: boolean };
export const DistributionBackContext = createContext<((back: BackAction | null) => void) | null>(null);

export function DistributionPanelFrame({ children }: { children: ReactNode }) {
	const [back, setBack] = useState<BackAction | null>(null);
	const register = useCallback((value: BackAction | null) => setBack(value), []);
	const t = useT();
	const { locale } = useI18n();
	return (
		<DistributionBackContext.Provider value={register}>
			<ModalHeader closeLabel={t("common.close")}>
				<span className="row-actions">
					{back && (
						<Button
							variant="ghost"
							size="icon"
							disabled={back.disabled}
							onClick={back.go}
							aria-label={pick(locale, ["Back", "返回"])}
							title={pick(locale, ["Back", "返回"])}
						>
							<ArrowLeft size={16} />
						</Button>
					)}
					{t("smartDistribution.heading")}
				</span>
			</ModalHeader>
			<div className="article-distribution-panel-body">{children}</div>
		</DistributionBackContext.Provider>
	);
}
